<template>
  <div class="animated fadeIn">
    <div class="d-flex align-items-center">
      <router-link 
        v-if="isEdit" 
        :to="{ name: 'VehicleList', query: $route.query }" 
        class="mr-3">
        <i class="icon-arrow-left" />
        Back
      </router-link>
      <h4 class="page-title mb-0">
        VRMS - {{ isEdit ? 'Edit' : 'Add' }} Record
      </h4>
    </div>
    <hr >
    <b-row align-h="center">
      <b-col sm="6">
        <div v-if="!isEdit">
          <b-form-group label="Batch File">
            <b-form-file
              v-model="logCards"
              :state="Boolean(logCards)"
              multiple
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..." />
          </b-form-group>
          <b-btn
            size="sm"
            variant="primary">
            Upload
          </b-btn>
          <hr>
        </div>
        <b-form class="main-form">
          <div class="d-flex align-items-center">
            <b-form-group label="License Plate">
              <div class="d-flex">
                <b-input
                  v-model="vehicleForm.licensePlate"
                  class="flex-fill"
                  size="sm"/>
                <b-btn
                  v-if="!isEdit"
                  ref="btn"
                  :disabled="isFetching"
                  class="ml-3 flex-fill"
                  variant="success"
                  size="sm"
                  @click="fetchCarDevice">
                  Fetch
                </b-btn>
              </div>
            </b-form-group>
          </div>
          <b-form-group label="Vehicle ID">
            <b-input
              v-model="vehicleForm.vehicleId"
              size="sm"
              disabled/>
          </b-form-group>
          <b-form-group label="Current State">
            <b-form-radio-group
              v-model="vehicleForm.currentState"
              :options="stateOptions"
              :disabled="isEdit"
              name="radio-options" />
          </b-form-group>
          <b-form-group label="Vehicle Owner">
            <b-input
              v-model="vehicleForm.vehicleOwner"
              :disabled="isEdit"
              size="sm"/>
          </b-form-group>
          <b-form-group label="Make">
            <b-input
              v-model="vehicleForm.make"
              :disabled="isEdit"
              size="sm"/>
          </b-form-group>
          <b-form-group label="Model">
            <b-input
              v-model="vehicleForm.model"
              :disabled="isEdit"
              size="sm"/>
          </b-form-group>
          <b-form-group label="Colour">
            <b-input
              v-model="vehicleForm.colour"
              :disabled="isEdit"
              size="sm"/>
          </b-form-group>
          <b-form-group label="Registration Date">
            <date-picker
              v-model="vehicleForm.registrationDate"
              :shortcuts="false"
              format="YYYY-MM-DD"
              width="100%"
              lang="en" />
          </b-form-group>
          <b-form-group label="Chasis Number">
            <b-input
              v-model="vehicleForm.chasisNumber"
              :disabled="isEdit"
              size="sm"/>
          </b-form-group>
          <b-form-group label="Engine Number">
            <b-input
              v-model="vehicleForm.engineNumber"
              :disabled="isEdit"
              size="sm"/>
          </b-form-group>
          <b-form-group label="IU Number">
            <b-input
              v-model="vehicleForm.iuNumber"
              size="sm" />
          </b-form-group>
          <b-form-group label="ARF Paid">
            <b-input
              v-model="vehicleForm.arfPaid"
              :disabled="isEdit"
              size="sm"/>
          </b-form-group>
          <b-form-group label="COE Paid">
            <b-input
              v-model="vehicleForm.coePaid"
              :disabled="isEdit"
              size="sm" />
          </b-form-group>
          <b-form-group label="Road Tax Amount">
            <b-input
              v-model="vehicleForm.roadTaxAmount"
              size="sm"/>
          </b-form-group>
          <b-form-group label="Next Road Tax Renewal">
            <date-picker
              v-model="vehicleForm.nextRoadTaxRenewal"
              :shortcuts="false"
              :disabled="isEdit"
              format="YYYY-MM-DD"
              width="100%"
              lang="en" />
          </b-form-group>
          <b-form-group label="Insurance Cover By">
            <b-input
              v-model="vehicleForm.insuranceCoverBy"
              size="sm" />
          </b-form-group>
          <b-form-group label="Insurance Premium">
            <b-input
              v-model="vehicleForm.insurancePremium"
              size="sm"/>
          </b-form-group>
          <b-form-group label="Insurance Certificate">
            <div
              v-for="certificate in vehicleForm.insuranceCertificate"
              :key="certificate.fileName"
              class="input-group mb-2">
              <a 
                :href="certificate.fileUrl" 
                target="_blank">{{ certificate.fileName }}</a>
              <b-btn
                v-if="certificate"
                class="ml-3"
                size="sm"
                variant="success"
                title="Share to Email"
                @click="handleShare(certificate)">
                <i class="icon-share-alt" />
              </b-btn>
            </div>
            <b-form-file
              v-model="localCertificates"
              :state="Boolean(localCertificates)"
              multiple
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..." />
          </b-form-group>
          <b-form-group label="Next Premium Renewal Date">
            <date-picker
              v-model="vehicleForm.nextPremiumRenewalDate"
              :shortcuts="false"
              format="YYYY-MM-DD"
              width="100%"
              lang="en" />
          </b-form-group>
          <b-form-group label="Date Sold">
            <date-picker
              v-model="vehicleForm.dateSold"
              :shortcuts="false"
              format="YYYY-MM-DD"
              width="100%"
              lang="en" />
          </b-form-group>
          <b-form-group label="Selling Price">
            <b-input
              v-model="vehicleForm.sellingPrice"
              size="sm"/>
          </b-form-group>
          <b-form-group label="Purchase's Name">
            <b-input
              v-model="vehicleForm.purchaserName"
              size="sm"/>
          </b-form-group>
          <b-form-group label="Category">
            <b-input
              v-model="vehicleForm.category"
              size="sm"
              disabled/>
          </b-form-group>
          <b-form-group label="Current Station">
            <b-input
              v-model="vehicleForm.currentStation"
              size="sm"
              disabled/>
          </b-form-group>
          <b-form-group label="Date Started at Current Station">
            <b-input
              v-model="dateStartedStation"
              size="sm"
              disabled/>
          </b-form-group>
          <b-form-group label="iBoxx Label No">
            <b-input
              v-model="vehicleForm.iBoxxLabelNo"
              size="sm"
              disabled/>
          </b-form-group>
          <b-form-group label="iBox QNR">
            <b-input
              v-model="vehicleForm.iBoxQnr"
              size="sm"
              disabled/>
          </b-form-group>
          <b-form-group label="iBoxxVersion">
            <b-input
              v-model="vehicleForm.iBoxxVersion"
              size="sm"
              disabled/>
          </b-form-group>
          <b-form-group label="SIM (Telephone Number)">
            <b-input
              v-model="vehicleForm.sim"
              size="sm"
              disabled/>
          </b-form-group>
          <b-form-group label="Telco">
            <b-input
              v-model="vehicleForm.telco"
              size="sm"
              disabled/>
          </b-form-group>
          <b-form-group label="Remark / Notes">
            <b-textarea
              v-model="vehicleForm.remark"
              size="sm"/>
          </b-form-group>
          <b-btn
            :disabled="isPosting"
            size="sm"
            variant="primary"
            block
            @click="handleSubmit">
            <i 
              v-if="isPosting" 
              class="fa fa-spin fa-spinner mr-1" />
            Submit
          </b-btn>
        </b-form>
      </b-col>
    </b-row>
    <ShareCertificateModal
      :license-plate="vehicleForm.licensePlate"
      :attachment="selectedCertificate"
      @submitted="shareCertSubmitted" />
  </div>
</template>
<script>
import uniqBy from 'lodash/uniqBy'
import DatePicker from 'vue2-datepicker'
import { mapState } from 'vuex'
import moment from 'moment'
import clone from 'lodash/clone'
import { toastr } from '@/services'
import ShareCertificateModal from './ShareCertificateModal'

export default {
  name: 'VehicleRecord',
  components: {
    DatePicker,
    ShareCertificateModal
  },
  data () {
    return {
      selectedCertificate: '',
      vehicleForm: {},
      localCertificates: [],
      logCards: [],
      stateOptions: [
        'Active',
        'Inactive'
      ],
      isPosting: false
    }
  },
  computed: {
    ...mapState('vrms', [
      'vehicleList',
      'vehicle',
      'isFetching',
      'existingCerts'
    ]),
    isEdit () {
      return this.$route.query.licensePlate ? true : false
    },
    dateStartedStation: {
      get () {
        if (!this.vehicleForm.dateStartedCurrentStation) return ''
        return moment(this.vehicleForm.dateStartedCurrentStation).utcOffset(8).format('DD-MM-YYYY')
      },
      set (val) {
        this.vehicleForm.dateStartedCurrentStation = val
      }
    }
  },
  created () {
    if (this.$route.query.licensePlate) {
      this.vehicleForm.licensePlate = this.$route.query.licensePlate
      this.handleFetch()
    }
  },
  methods: {
    async handleFetch () {
      this.$store.dispatch('vrms/fetchVehicleBy', this.vehicleForm.licensePlate)
        .then(() => this.vehicleForm = clone(this.vehicleList.map(obj => obj)[0]))
      await this.$store.dispatch('vrms/getInsurances', { licensePlate: this.vehicleForm.licensePlate })
    },
    fetchCarDevice () {
      const licensePlate = this.vehicleForm.licensePlate
      this.$store.dispatch('vrms/fetchCarDevice', { licensePlate: licensePlate.toUpperCase() }).then(() => {
        if (!this.vehicleList.length) {
          toastr.info('No vehicle found')
          return
        }
        this.vehicleForm = clone(this.vehicleList.map(obj => obj)[0])
      }).catch(err => {
        toastr.serverError()
      })
    },
    handleShare (cert) {
      this.selectedCertificate = cert.fileName
      this.$bvModal.show('share-modal')
    },
    async handleSubmit (e) {
      try {
        e.preventDefault()
        this.isPosting = true
        // re-sync certs
        await this.$store.dispatch('vrms/getInsurances', { licensePlate: this.vehicleForm.licensePlate })
        // normalized form
        const dateFormat = 'YYYY-MM-DD'
        const { dateSold, nextPremiumRenewalDate, registrationDate } = this.vehicleForm
        this.vehicleForm.dateSold = this.$options.filters.date(dateSold, dateFormat)
        this.vehicleForm.nextPremiumRenewalDate = this.$options.filters.date(nextPremiumRenewalDate, dateFormat)
        this.vehicleForm.registrationDate = this.$options.filters.date(registrationDate, dateFormat)
        let certUploaded = undefined
        if (this.localCertificates.length) {
          certUploaded = await this.$store.dispatch('vrms/uploadCertificate', {
            certs: this.localCertificates, licensePlate: this.vehicleForm.licensePlate
          })
        }
        if (certUploaded) {
          const arr = certUploaded.msgContent.data
          this.vehicleForm.insuranceCertificate = uniqBy([...arr, ...this.existingCerts], 'fileName')
        } else {
          this.vehicleForm.insuranceCertificate = this.existingCerts
        }
        await this.$store.dispatch('vrms/saveVehicleRecord', [this.vehicleForm])
        this.isPosting = false
        toastr.success(false, 2000)
        this.$store.commit('vrms/RESET_FORM')
      } catch (err) {
        console.log(err)
        this.isPosting = false
        toastr.serverError()
      }

    },
    shareCertSubmitted (payload) {
      this.$store.dispatch('vrms/shareCertificate', payload)
      this.$bvModal.hide('share-modal')
    }
  }
}
</script>
<style lang="scss" scoped>
.main-form {
  padding: 1rem;
  border: 1px solid #ced4da;
}
</style>